import { render, staticRenderFns } from "./ServiceAdd.vue?vue&type=template&id=69283bbb&"
import script from "./ServiceAdd.vue?vue&type=script&lang=js&"
export * from "./ServiceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports